import React, { useLayoutEffect, useRef } from 'react';

/* A textarea that grows with what is in it. A box that hides half of what you
   wrote is a box you stop trusting — members were scrolling inside it to check
   their own sentences were still there. */
const AutoTextarea = React.forwardRef(function AutoTextarea({ value, ...rest }, forwarded) {
  const own = useRef(null);
  const ref = forwarded || own;

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = 'auto';
    el.style.height = `${Math.min(el.scrollHeight + 2, Math.round(window.innerHeight * 0.5))}px`;
  }, [value, ref]);

  return <textarea {...rest} value={value} ref={ref} />;
});

export default AutoTextarea;
